import React, { CSSProperties } from 'react';
import { Link as ReactLink } from "react-router-dom";
import { Link as MuiLink } from '@mui/material'

const Link: React.FC<LinkProps> = props => {
    const style: CSSProperties = {
        textDecoration: 'none',
    };

    if (props.inheritColor) {
        style.color = 'inherit';
    }

    const isExternalLink: boolean = !!props.to.match(/^https?:/);

    if (!isExternalLink) {
        return (
            //@ts-ignore
            <MuiLink
                href={ props.to }
                to={ props.to }
                style={ style }
                target={ props.target }
                underline='none'
                component={ ReactLink }
            >
                { props.children }
            </MuiLink>
        );
    }

    return (
        <MuiLink
            href={ props.to }
            style={ style }
            target={ props.target }
            underline='none'
        >
            { props.children }
        </MuiLink>
    );
}
export default Link;

export interface LinkProps {
    readonly to: string;
    readonly target?: LinkTarget;
    readonly inheritColor?: boolean;
    readonly children?: any;
}

type LinkTarget = '_blank' | '_parent' | '_self' | '_top';